module.exports = __webpack_public_path__ + "img/product-showcase-image-02.9bc56a07.jpg";